import heatOrCombi, { HeatOrCombiStepContext } from '~/steps/heat-or-combi';
import emobilityInterest, {
  EmobilityInterestStepContext,
} from '~/steps/emobility/interest';
import emobilityBuy, { EmobilityBuyStepContext } from '~/steps/emobility/buy';
import solarSteps, { SolarAssistantContext } from '~/steps/solar/steps';
import heatingSteps, { HeatingAssistantContext } from '~/steps/heating/steps';
import combiSteps, { CombiAssistantContext } from '~/steps/combi/steps';
import assistantSubmit, { AssistantSubmitStepContext } from '~/steps/submit';
import solarOffer, { SolarOfferStepContext } from '~/steps/solar/offer';

// Add the imported StepDefinition from the steps in the order
// the steps should be shown in the assistant.
const steps = [
  // Entry page of the print/QR campaign. Kept in front of the assistants so it
  // never becomes the PREV target of one of their first steps - it is only
  // reached by an explicit jump.
  heatOrCombi,
  emobilityInterest,
  emobilityBuy,
  ...solarSteps,
  solarOffer,
  ...heatingSteps,
  ...combiSteps,
  assistantSubmit,
];

// Add the imported context interface for the steps
export interface AssistantContext
  extends SolarAssistantContext,
    HeatingAssistantContext,
    CombiAssistantContext {
  heatOrCombi: HeatOrCombiStepContext;
  solarOffer: SolarOfferStepContext;
  emobilityInterest: EmobilityInterestStepContext;
  emobilityBuy: EmobilityBuyStepContext;
  assistantSubmit: AssistantSubmitStepContext;
}

export default steps;
